export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly retryable: boolean;
  readonly requestId?: string;
  readonly details?: unknown;

  constructor(input: {
    status: number;
    code: string;
    message: string;
    retryable?: boolean;
    requestId?: string;
    details?: unknown;
  }) {
    super(input.message);
    this.name = 'ApiError';
    this.status = input.status;
    this.code = input.code;
    this.retryable = Boolean(input.retryable);
    this.requestId = input.requestId;
    this.details = input.details;
  }
}
